<template functional>
  <div>
    <a href="#" @click="$options.show(props)">{{
      props.row.FidelizacionQty
    }}</a>
  </div>
</template>

<script>
import store from "../../../../store/index";
export default {
  name: "fideLink",
  show(ops) {
    store.dispatch("getAllTerminalAndServicesAsync", {
      Rnc: ops.row.Rnc,
      type: 3
    });
  }
};
</script>
